







import Vue from "vue";
import { Component } from "vue-property-decorator";
import SgsLayout from "@/components/SgsLayout.vue"
import SgsVersion from "@/components/SgsVersion.vue";

import { env } from '@/env';

@Component({
  name: "HomeComponent",
  components: {
    SgsLayout, SgsVersion
  }
})
export default class HomeComponent extends Vue {
  private appName = env.appName !== '' ? env.appName : 'ADD TITLE HERE';
}
